// extracted by mini-css-extract-plugin
export default {"list":"YourDataInfo3_list__xtcDQ","listItem":"YourDataInfo3_listItem__0XqN9"};